import {
  ShippingMarginOverTimeRequestSchema,
  ShippingMarginOverTimeResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getShippingMarginOverTime = {
  name: "getShippingMarginOverTime" as const,
  input: ShippingMarginOverTimeRequestSchema,
  output: ShippingMarginOverTimeResponseSchema,
};
